.container {
  display: inline-flex;
  align-items: center;
  border: 1px solid var(--color-border);
  border-radius: map.get($radius, 'full');
  overflow: hidden;
}

.segment {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 32px;
  padding: 0;
  border: none;
  background: transparent;
  color: var(--color-text-tertiary);
  cursor: pointer;
  @include transition(background-color, color);

  &:not(:last-child) {
    border-right: 1px solid var(--color-border);
  }

  &:hover:not(.active):not(:disabled) {
    background-color: var(--color-grey-light);
  }

  &:focus-visible {
    outline: 2px solid var(--color-primary-base);
    outline-offset: -2px;
    z-index: 1;
  }

  &:disabled {
    cursor: not-allowed;
  }
}

.active {
  background-color: var(--color-primary-base);
  color: var(--color-primary-on-primary);

  &:hover:not(:disabled) {
    background-color: var(--color-primary-dark);
  }
}

.disabled {
  opacity: 0.5;
  pointer-events: none;
}

.iconWrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
}
